import { render, staticRenderFns } from "./ProductDetailDialog.vue?vue&type=template&id=9cc70be6&scoped=true&"
import script from "./ProductDetailDialog.vue?vue&type=script&lang=js&"
export * from "./ProductDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailDialog.vue?vue&type=style&index=0&id=9cc70be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc70be6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VDataTable,VDialog,VRow,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cc70be6')) {
      api.createRecord('9cc70be6', component.options)
    } else {
      api.reload('9cc70be6', component.options)
    }
    module.hot.accept("./ProductDetailDialog.vue?vue&type=template&id=9cc70be6&scoped=true&", function () {
      api.rerender('9cc70be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lcd/views/Contents/modal/ProductDetailDialog.vue"
export default component.exports